import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Collapse, Nav, Navbar } from 'reactstrap';
import moment from 'moment';
import i18next from 'i18next';
import 'moment/locale/fr';
import AvatarButton from './avatar_button';
import KebabButton from './kebab_button';
import { useClassNameState } from './useClassNameState';
import { PrivateComponent } from '../permissions';
import NotificationWidget from './notification_widget';
import { getFeatureByPath } from '../routing/services';
import { getUserProfile } from '../../redux/userProfile/userProfileActions';
import { getFeatures } from '../../redux/app/appActions';
import { logout } from '../../redux/app/appSlice';
import logoImage from '../../assets/vrr/images/logo_vrr_red.svg';
import './TopBar.scss';

export const TopBar: React.FC = () => {
  moment.locale(i18next.language);
  const [collapseOpen, setCollapseOpen] = useState<boolean>(false);
  const { currentClassName, setCurrentClassName } = useClassNameState(
    'navbar-transparent',
    collapseOpen
  );
  const dispatch: any = useDispatch();
  const features = useSelector(getFeatures);
  const currentUserProfile = useSelector(getUserProfile);

  const toggleCollapse = () => {
    setCurrentClassName(collapseOpen ? 'navbar-transparent' : 'bg-white');
    setCollapseOpen(!collapseOpen);
  };

  return (
    <Navbar className={`vrr-top-bar ${currentClassName}`} expand="lg">
      <div className="logo">
        <div className="logo-img">
          <img src={logoImage} alt="vrr-logo" />
        </div>
      </div>
      <Container fluid className="vrr-top-bar-container">
        <KebabButton onOpen={toggleCollapse} />
        <Collapse navbar isOpen={collapseOpen} className="vrr-top-bar-collapse">
          <Nav className="ml-auto" navbar>
            <PrivateComponent
              authorizationStrategy={() =>
                getFeatureByPath(features, 'notifications.access')
              }
            >
              <NotificationWidget />
            </PrivateComponent>
            <AvatarButton
              username={currentUserProfile.username}
              logoutAction={() => {
                dispatch(logout());
              }}
            />
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default TopBar;
